var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.083,
    height: 15.083,
    viewBox: "0 0 15.083 15.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_edit_3451588",
    transform: "translate(-2 -2.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65226",
    "data-name": "Path 65226",
    d: "M13.641,17.968H4.328A2.328,2.328,0,0,1,2,15.64V6.327A2.328,2.328,0,0,1,4.328,4h3.1a.776.776,0,1,1,0,1.549h-3.1a.776.776,0,0,0-.779.779V15.64a.776.776,0,0,0,.776.776h9.316a.776.776,0,0,0,.776-.776v-3.1a.776.776,0,0,1,1.549,0v3.1A2.328,2.328,0,0,1,13.641,17.968Z",
    transform: "translate(0 -0.321)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65227",
    "data-name": "Path 65227",
    d: "M13.234,5.87,9.4,9.751a.318.318,0,0,0-.1.179L8.516,12.9a.372.372,0,0,0,.1.372.364.364,0,0,0,.269.077.249.249,0,0,0,.1,0l2.964-.776a.318.318,0,0,0,.179-.1l3.839-3.857Z",
    transform: "translate(-1.456 -0.74)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65228",
    "data-name": "Path 65228",
    d: "M19.881,4.028,18.755,2.9a1.179,1.179,0,0,0-1.653,0L16,4.028l2.755,2.755,1.126-1.1a1.179,1.179,0,0,0,0-1.653Z",
    transform: "translate(-3.136)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditprofile);
export default __webpack_public_path__ + "static/media/editprofile.d371b13d9dcd3ca9be6c80dd53694dad.svg";
export { ForwardRef as ReactComponent };